import { AuthProvider, useAuthContext } from './contexts/AuthProvider';
import { PermissionProvider } from '@contexts/PermissionProvider';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';

import {
  BudgetExpenseDraftSummaryPage,
  BudgetExpenseGridPage,
  BudgetIncomePage,
  BudgetTemplatePage,
  CategoryPage,
  ConsolidatedBudgetDetailsPage,
  ConsolidatedBudgetEvolutionPage,
  ConsolidatedBudgetPage,
  CostCenterPage,
  DefaultPage,
  EmailSentPage,
  HomePage,
  LoginPage,
  MePage,
  NotFoundPage,
  RecoverPasswordPage,
  ResetPasswordPage,
  TransactionPage,
  UserPage,
} from '@pages';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ConfirmationModalProvider } from '@contexts/ConfirmationContext';
import { CostCenterFromToPage } from '@pages/CostCenterFromToPage';
import { CollaboratorPage } from '@pages/CollaboratorPage';
import { BudgetEstimatePage } from '@pages/BudgetEstimatePage';
import { AccessPage } from '@pages/AccessPage';
import { FiltersProvider } from '@contexts/FiltersContext';

function Authenticated() {
  const location = useLocation();
  const { user, loading } = useAuthContext();

  if (loading) {
    return <>Loading, please wait...</>;
  }

  const isAuthenticated = !!user;
  return isAuthenticated ? (
    <DefaultPage />
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
}

function App() {
  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <BrowserRouter>
        <ConfirmationModalProvider>
          <AuthProvider>
            <PermissionProvider>
              <FiltersProvider>
                <Routes>
                  <Route path="">
                    <Route path="" element={<LoginPage />} />
                    <Route path="login" element={<LoginPage />} />
                    <Route path="recover_password">
                      <Route path="" element={<RecoverPasswordPage />} />
                      <Route path=":token" element={<ResetPasswordPage />} />
                    </Route>
                    <Route path="email_sent" element={<EmailSentPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                  </Route>
                  <Route path="" element={<Authenticated />}>
                    <Route path="/users" element={<UserPage />} />
                    <Route path="/me" element={<MePage />} />
                    <Route
                      path="/budget-consolidado"
                      element={<ConsolidatedBudgetPage />}
                    />
                    <Route
                      path="/budget-consolidado/:budgetTemplateId/:costCenterId"
                      element={<ConsolidatedBudgetDetailsPage />}
                    />
                    <Route
                      path="/budget-consolidado/:budgetTemplateId/:costCenterId/:type"
                      element={<ConsolidatedBudgetEvolutionPage />}
                    />
                    <Route path="/home" element={<HomePage />} />
                    <Route
                      path="/budget-despesas"
                      element={<Navigate to="/budget-despesas-grid" replace />}
                    />
                    <Route
                      path="/budget-despesas-grid"
                      element={<BudgetExpenseGridPage />}
                    />
                    <Route
                      path="/budget-despesas-revisao"
                      element={<BudgetExpenseDraftSummaryPage />}
                    />
                    <Route path="/categorias" element={<CategoryPage />} />
                    <Route path="/centros-custo" element={<CostCenterPage />} />
                    <Route
                      path="/centros-custo-de-para"
                      element={<CostCenterFromToPage />}
                    />
                    <Route
                      path="/budget-receitas"
                      element={<BudgetIncomePage />}
                    />
                    <Route path="/realizado" element={<TransactionPage />} />
                    <Route
                      path="/modelos-budget"
                      element={<BudgetTemplatePage />}
                    />
                    <Route path="/access" element={<AccessPage />} />
                    <Route
                      path="/colaboradores"
                      element={<CollaboratorPage />}
                    />
                    <Route
                      path="/estimativa-colaboradores"
                      element={<BudgetEstimatePage />}
                    />
                  </Route>
                </Routes>
              </FiltersProvider>
            </PermissionProvider>
          </AuthProvider>
        </ConfirmationModalProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
